import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { itemsEvaluacionPGDFetch, observacionesEvaluacionPGD } from "../../Redux/evaluaciones";

const useItemsCompetencias = (token, id) => {
  const dispatch = useDispatch();

  const [complete, setComplete] = useState(false)
  const [ponderationTotal, setPonderationTotal] = useState(0)

  const [openModalCompetencia, setOpenModalCompetencia] = useState(false)

  const [itemsEvaluacionPGD, setItemsEvaluacionPGD] = useState([])

  const [targetCompetencia, setTargetCompetencia] = useState({})

  const itemsEvaluacionPGDSelector = useSelector((store) => store.evaluaciones.itemsEvaluacionPGD)

  const [getItemsEvaluacionPDG, setGetItemsEvaluacionPDG] = useState(false)

  const getItemsEvaluacionPDGSelector = useSelector((store) => store.evaluaciones.getItemsEvaluacionPDG)

  useEffect(() => {
    let ponderationTotal = 0;
    let interrupted = false;
    itemsEvaluacionPGD.forEach(item=> {
      if (item.valoracionLiderModal && !item.valoracionLiderModal?.value) {
        interrupted = true;
        return;
      }
      ponderationTotal+=item.valoracionLiderModal?.ponderation
    });
    if (!interrupted) {
      let valorPromediado = ponderationTotal / itemsEvaluacionPGD.length;
      setPonderationTotal(valorPromediado);
    }
  }, [itemsEvaluacionPGD])


  useEffect(() => {
    if (token && id) {
      dispatch(itemsEvaluacionPGDFetch(token, id))
    }
  }, [id, token])
  
  useEffect(() => {
    if (itemsEvaluacionPGDSelector?.length > 0 && getItemsEvaluacionPDGSelector) {
      const array = []
      let completed = true;
      itemsEvaluacionPGDSelector.forEach((items) => {
        if(!items["new_valoraciondellider"] || !items["new_valoracin"]) {
          completed = false;
        }
        let item = {
          id: items["new_itemdeevaluaciondedesempeoid"],
          competencia: items["_new_competencia_value@OData.Community.Display.V1.FormattedValue"],
          valoracionModal: { value: items["new_valoracin"], label: items["new_valoracin@OData.Community.Display.V1.FormattedValue"],
            ponderation: items["new_valoracin"] ? (parseInt(items["new_valoracin"].toString().slice(-1))+1) : undefined
          },
          valoracionLiderModal: { value: items["new_valoraciondellider"], label: items["new_valoraciondellider@OData.Community.Display.V1.FormattedValue"],
            ponderation: items["new_valoraciondellider"] ? (parseInt(items["new_valoraciondellider"].toString().slice(-1))+1)  : undefined
          },
          definicionderangos: items["aa.new_definicionderangos"],
          descripcion: items["aa.new_descripcion"],
        }
        array.push(item)
      })
      setItemsEvaluacionPGD(array)
      setGetItemsEvaluacionPDG(getItemsEvaluacionPDGSelector)

      
      if(completed) {
        setComplete(true);
      }

    } else if (itemsEvaluacionPGDSelector?.length === 0 && getItemsEvaluacionPDGSelector) {
      setGetItemsEvaluacionPDG(getItemsEvaluacionPDGSelector)
    }

  }, [itemsEvaluacionPGDSelector])

  const handleOpenModalCompetencia = (id) => {
    if (id) {
      setTargetCompetencia(itemsEvaluacionPGD?.find((item) => item.id === id))
      setOpenModalCompetencia(true)
    }
  }
    
  const handleCloseModalCompetencia = (/*itemCompetencia*/) => {
    // if (itemCompetencia) {
    //     let index = itemsEvaluacionPGD.findIndex((item) => item.id === itemCompetencia.id);
    //     if (index !== -1) {
    //       const nuevosItemsDeEvaluacion = [...itemsEvaluacionPGD];

    //       if(itemsEvaluacionPGD[index].valoracionModal && itemCompetencia.valoracionModal && (itemsEvaluacionPGD[index].valoracionModal.value !=itemCompetencia.valoracionModal.value)) {
    //         nuevosItemsDeEvaluacion[index].valoracionModal = itemCompetencia.valoracionModal;
    //         setItemsEvaluacionPGD(nuevosItemsDeEvaluacion);
    //       }
    //       else if(itemsEvaluacionPGD[index].valoracionLiderModal && itemCompetencia.valoracionLiderModal && (itemsEvaluacionPGD[index].valoracionLiderModal.value !=itemCompetencia.valoracionLiderModal.value)) {
    //         nuevosItemsDeEvaluacion[index].valoracionLiderModal = itemCompetencia.valoracionLiderModal;
    //         setItemsEvaluacionPGD(nuevosItemsDeEvaluacion);
    //       } else {
    //         // console.log("no hubo cambios");
    //       }
    
    //   }
    // }

    setOpenModalCompetencia(false)
    setTargetCompetencia({})  
  };

  return {getItemsEvaluacionPDG, itemsEvaluacionPGD, targetCompetencia, setGetItemsEvaluacionPDG, setItemsEvaluacionPGD, setTargetCompetencia, handleOpenModalCompetencia, handleCloseModalCompetencia, openModalCompetencia, setOpenModalCompetencia, complete, setComplete, ponderationTotal }
}

export default useItemsCompetencias